import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from 'lib/style-utils';
import { BabyTable, KidsTable } from './SizeTable';
import BodySuit from './BodySuit';

const Wrapper = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  transition: all 0.8s;
`;

/** Brand Logo */
const Logo = styled.img`
  display: block;
  width: 422px;
  margin: 143px auto 53px;
  transition: all 0.8s;

  ${media.w1200`
    width: 300px;
  `} ${media.mobile`
    width: 193px;
    margin: 60px auto 40px;
  `};
`;

/** Color Dot */
const Dot = styled.div`
  width: 10px;
  height: 10px;
  margin: 98px auto 14px;
  border-radius: 50%;
  background: ${props => props.color};
  transition: all 0.8s;

  ${media.mobile`
    margin: 70px auto 14px;

    &.size {
      margin-top: 83px;
    }
  `} &.body {
    margin-top: 110px;

    ${media.mobile`
    margin-top: 90px;
    `};
  }
`;

/** About Brand */
const Description = styled.div`
  font-family: 'Noto Sans KR', sans-serif;
  text-align: center;
  font-size: 18px;
  line-height: 1.9;
  color: #444444;
  padding: 0 10px;
  transition: all .8s;

  & .mobile.hidden {
    display: block;
  }
  & .mobile.show {
    display: none;
  }
  & .tablet.show {
    display: none;
  }

  ${media.w1200`
    font-size: 16px;
  `}
  ${media.tablet`
    & .mobile.hidden {
      display: none;
    }
    & .tablet.show {
      display: block;
    }
  `}
  ${media.mobile`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.87;

    & .tablet.show {
      display: none;
    }
    & .mobile.show {
      display: block;
      text-align: center;
      word-break: keep-all;

    }
  `}
  ${media.se`
    & .mobile.show {
      font-size: 14px;
    }
  `}
`;

/** Column Title */
const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 1.2px;
  color: #343434;
  margin-bottom: 50px;
  transition: all 0.8s;

  ${media.mobile`
    margin-bottom: 37px;
    font-size: 21px;
    letter-spacing: 1;

    &.title-kicker {
      margin-bottom: 0;
    }
  `};
`;

/** Column - Sub Title */
const SubTitle = styled.div`
  margin-bottom: 25px;
  font-family: 'Noto Sans KR';
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-align: center;
  color: #555555;
  transition: all 0.8s;

  &.second-subtitle {
    margin-top: 70px;

    ${media.mobile`
      margin-top: 49px;
    `};
  }

  ${media.mobile`
    font-size: 15px;
  `};
`;

class Desc extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  render() {
    const { color } = this.props;

    return (
      <Wrapper>
        <Logo src="/images/logo/logo.png" alt="" />
        <Description>
          <div className="mobile hidden">
            <p>
              미국에서 탄생한 브랜드 베이비디디(Babydeedee)는 아이들의 숙면을
              돕기 위한
            </p>
            <p>
              슬리핑백을 직접 제작하며 시작된 브랜드입니다.수트 형태부터
              코쿤모양의 슬리핑백까지 다양한 베이비 슬립기어(Sleep Gear)를
              선보이고
            </p>
            <p>
              있는 베이비디디는 다수의 프로덕트 어워즈에서 수상하며 제품력을
              인정받은 바 있습니다.
            </p>
          </div>

          <div className="tablet show">
            <p>
              미국에서 탄생한 브랜드 베이비디디(Babydeedee)는 아이들의 숙면을
              돕기 위한
            </p>
            <p>슬리핑백을 직접 제작하며 시작된 브랜드입니다.</p>
            <p>
              수트 형태부터 코쿤모양의 슬리핑백까지 다양한 베이비 슬립기어(Sleep
              Gear)를 선보이고
            </p>
            <p>
              있는 베이비디디는 다수의 프로덕트 어워즈에서 수상하며 제품력을
              인정받은 바 있습니다.
            </p>
          </div>

          <div className="mobile show">
            <p>
              미국에서 탄생한 브랜드 베이비디디(Babydeedee)는 아이들의 숙면을
              돕기 위한 슬리핑백을 직접 제작하며 시작된 브랜드입니다. 수트
              형태부터 코쿤모양의 슬리핑백까지 다양한 베이비 슬립기어(Sleep
              Gear)를 선보이고 있는 베이비디디는 다수의 프로덕트 어워즈에서
              수상하며 제품력을 인정받은 바 있습니다.
            </p>
          </div>
        </Description>

        <Dot className="size" color={color} />
        <Title>SIZE</Title>
        <SubTitle>슬립시 숏 / 슬립시 롱 / 슬립 퀼트 사이즈 공통</SubTitle>
        <BabyTable />
        <SubTitle className="second-subtitle">슬립 키커</SubTitle>
        <KidsTable />

        <Dot className="body" color={color} />
        <Title
          className="title-kicker"
          style={{ fontFamily: 'Noto Sans KR', fontWeight: '500' }}
        >
          슬립시 &amp; 슬립키커
        </Title>

        <BodySuit />
      </Wrapper>
    );
  }
}

export default Desc;



// WEBPACK FOOTER //
// ./src/components/About/Desc.js